import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import Qs from 'qs' 

import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
// 将 axios 挂载到 Vue 原型上
Vue.prototype.$axios = axios
Vue.prototype.$url = process.env.VUE_APP_URL;
Vue.prototype.$codeUrl = 'https://xxx/';
// 配置默认请求头（可选）
// axios.defaults.headers.common['Authorization'] = 'Bearer your-token'
// 配置默认基础 URL（可选）
axios.defaults.baseURL = process.env.VUE_APP_URL
Vue.use(ElementUI).use(mavonEditor)
Vue.config.productionTip = false
Vue.prototype.Qs = Qs

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
